const RenderingStyling = (rName) => {
  var opts = {};
  opts['data-widget-title'] = rName;
  return opts;
};

export default RenderingStyling;
